<template>
  <div
  id="app"
  class="backgroundImage"
  >
    <v-app
      style="background: rgba(0,0,0,0);color: #fff"
      >
        <v-container
          class="fill-height"
          fluid
        >
          <v-row
            align="center"
            justify="center"
          >
            <v-col
              cols="12"
              sm="8"
              md="4"
            >

              <v-card class="mx-auto pa-10" max-width="500">
                <v-card-title class="title font-weight-regular justify-space-between mb-10">
                  <v-img
                    src="@/assets/logo-primary.png"
                    height="70px"
                    contain
                  />
                </v-card-title>
                <v-card-text>
             
                  <v-text-field
                    v-model="form.email"
                    :rules="[rules.required, rules.email]"
                    label="E-mail"
                    name="login"
                    type="text"
                    background-color="#fff"
                    outlined
                  />
                  <v-text-field
                    id="password"
                    v-model="form.password"
                    :rules="[rules.required]"
                    label="Password"
                    name="password"
                    type="password"
                    background-color="#fff"
                    outlined
                  />
                  <v-btn
                    color="primary"
                    form="signInForm"
                    type="submit"
                    block
                    rounded
                    @click="signIn()"
                  >
                    {{ $t('sign-in') }}
                  </v-btn>
                  <div class="caption ma-5 text-center">
                    <a @click="$router.push('password')">Forgot your password?</a>
                  </div>

                  <div class="caption text-center">
                    Don't have an account? <a @click="$router.push('signup')">Sign up</a>
                  </div>
                
                </v-card-text>

              <!--

              <v-row justify="center" class="mb-5">
                <v-btn
                  color="info"
                  rounded
                  @click="$router.push('signup')"
                >
                  {{ $t('create-account') }}
                </v-btn>
              </v-row>
            -->
            </v-card>
            </v-col>
          </v-row>
        </v-container>
    </v-app>
  </div>
</template>

<script>
  import _ from 'lodash'
  
  export default {
    name: 'SignIn',

    data () {
      return {
        form: {
          email: '',
          password: '',
          firstName: '',
          lastName: '',
          companyName: '',
          companyNumber: null,
          invited: false,
        },
        signUp: false,
        rules: {
          required: value => !!value || 'Required.',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
        },
        error: null,
        queryTerm: '',
        companies: [],
        company: '',
        searchCompany: '',
        searchCompanyLoading: false,
      }
    },

    created () {
      this.$vuetify.theme.dark = false;
      if (this.$route.name === 'signup') {
        this.signUp = true;
      }
      if (this.$route.query.email) {
        this.form.email = this.$route.query.email
      }
      if (this.$route.query.company) {
        this.form.invited = true;
        this.form.companyName = this.$route.query.company;
      }
    },

    watch: {
      searchCompany (val, oldVal) {
        if (!val || val.lenght<2 || val===oldVal || this.searchCompanyLoading) {
          return;
        }
        this.queryCompanies(val)
      }
    },

    methods: {
      signIn () {
        this.$authService.authSignInWithEmail(this.form.email, this.form.password)
      },
      createAccount () {
        this.$authService.createNewAccount(this.form)
      },
      toggleSignUp () {
        this.signUp = !this.signUp
        if (this.signUp) {
          this.$router.replace('/signup')
        } else {
          this.$router.replace('/signin')
        }
      },
      queryCompanies: _.debounce(function(query) {
        if (!query) {
          return null
        }
        const q = query.split(' ').join('+');
        this.companies = []
        const proxyUrl = 'https://cors-anywhere.herokuapp.com/'
        const targetUrl = 'https://api.opencorporates.com/v0.4/companies/search?q='+q

        this.searchCompanyLoading = true;

        fetch(proxyUrl + targetUrl)
          .then(response => response.json())
          .then(data => {
            data.results.companies.forEach((item) => {
              this.companies.push(item.company)
            })
          })
          .catch((err)=> {
            console.log(err)
          })
          .finally(() => (this.searchCompanyLoading = false))
      }, 1200),
    },

  }
</script>

<style scoped>
  .backgroundImage {
    /*background-image: url("https://images.pexels.com/photos/3551197/pexels-photo-3551197.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260");*/
    background-image: url("https://images.pexels.com/photos/1054218/pexels-photo-1054218.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260");
    background-size: cover;
  }
  #adminAuth .theme--light .v-main {
    background: none;
  }

  /* Change the white to any color ;) */
  input:-webkit-autofill,
  input:-webkit-autofill:hover, 
  input:-webkit-autofill:focus, 
  input:-webkit-autofill:active  {
    box-shadow: 0;
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }

</style>
